<template>
    <div class="course">
        <!-- 查询、新增和删除操作 -->
        <el-form :inline="true" :model="courseQuery">
            <el-form-item>
                <el-input
                    placeholder="请输入标题"
                    width="100"
                    v-model="courseQuery.key"
                    clearable
                >
                </el-input>
            </el-form-item>
              <el-form-item>
                <el-select
                    v-model="courseQuery.videoType"
                    width="100"
                    clearable
                    placeholder="课程类型"
                >
                    <el-option
                        v-for="item in videoTypelist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAllCourseList(1)">查询</el-button>
                <el-button @click="addOrUpdateHandle"
                    >新增</el-button
                >
                <el-button
                    type="danger"
                    @click="multipleDelete"
                    :disabled="selectDelete.length <= 0"
                    >批量删除
                </el-button>
                <el-button type="warning" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="courseList"
            style="width: 100%"
            v-loading="loading"
            border
            @selection-change="handleSelectionChange"
            :default-sort = "{prop: 'sort', order: 'descending'}"
        >
            <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
            <el-table-column type="selection" width="50" align="center"> </el-table-column>
            <el-table-column
                label="标题"
                align="center"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span v-html="showcontent(scope.row.title)"></span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="description"
                label="描述"
                align="center"
                width="150"
                show-overflow-tooltip
            >
                <template slot-scope="scoped">
                    <span v-html="showcontent(scoped.row.description)"></span>   
                </template>
            </el-table-column> -->
            <el-table-column
                prop="origin"
                label="来源"
                align="center"
                width="100"
                show-overflow-tooltip
            >
            <template slot-scope="scope">
                    <span v-html="showcontent(scope.row.origin)"></span>
                </template>
            </el-table-column>
            <el-table-column
                prop="author"
                label="作者"
                align="center"
                width="100"
                show-overflow-tooltip
            >
            <template slot-scope="scope">
                    <span v-html="showcontent(scope.row.author)"></span>
                </template>
            </el-table-column>
            <el-table-column
                prop="videoType"
                label="类型"
                align="center"
                width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-tag
                    size="small"
                    :type="
                        scope.row.videoType === '0'?
                        '':scope.row.videoType === '1'?
                        'success':scope.row.videoType === '2'?
                        'danger':'warning'
                    "
                    >
                        {{
                            scope.row.videoType === '0'?
                            '电商运营':scope.row.videoType === '1'?
                            '法律':scope.row.videoType === '2'?
                            '活动':scope.row.videoType === '3'?
                            '共享培训课件':''
                        }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="课程视频"
                prop="thumb_"
                align="center"
                width="130"
            >
                <template slot-scope="scope">
                    <div class="img-show">
                        <el-image
                            v-if="scope.row.thumb != null"
                            width="75%"
                            contain
                            class="image-slot"
                            :src="scope.row.thumb"
                            fit="contain"
                            @click="videoPlay(scope.row.video)"
                        ></el-image>
                        <div v-else slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="playCount"
                label="播放次数"
                width="80"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                align="center"
                width="120"
            >
            </el-table-column>
            <el-table-column
                prop="updateTime"
                label="更新时间"
                align="center"
                width="120"
            >
            </el-table-column>
            <el-table-column
                prop="showStatus"
                label="状态"
                align="center"
                width="80"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        plain
                        class="padding-style"
                        :type="
                            scope.row.showStatus === '0' ? 'danger' : 'success'
                        "
                        @click="changeShow(scope.row)"
                    >
                        {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center" width="90">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        class="padding-style"
                        plain
                        :type="checkStyle(scope.row.checkStatus)"
                        @click="examineStatus(scope.row.id)"
                    >
                        {{ checkShow(scope.row.checkStatus) }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" align="center" width="70" >
                <template slot-scope="scope">
                    <el-input
                        class="e-input"
                        v-model.number="scope.row.sort"
                        @blur="updateSort(scope.row)"
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button
                        style="padding: 8px 2px 8px 0;"
                        type="text"
                        size="small"
                        @click="addOrUpdateHandle(scope.row.id)"
                    >
                        修改
                    </el-button>
                    <el-button
                        style="margin:0;padding:8px 2px 8px 0"
                        type="text"
                        size="small"
                        @click="deleteCourse(scope.row.id)"
                    >
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- banner分页器 -->
        <el-pagination
            background
            layout="total,prev, pager, next"
            :total="courseTotal"
            @current-change="pageChange"
            :page-size="courseQuery.limit"
            :current-page="courseQuery.page"
        >
        </el-pagination>
        <!-- 审核新添加列表的弹框 -->
        <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getAllCourseList()"
        />
        <!-- 视频播放弹出框 -->
        <el-dialog
            title="视频播放"
            :visible.sync="dialogVideoVisible"
            @close="parseVideo"
        >
            <video
                :src="videoUrl"
                controls
                :style="{ width: '100%', 'max-height': '400px' }"
                id="video-play"
            ></video>
        </el-dialog>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
            ref="addOrUpdate"
            @courseListUpdate="getAllCourseList"
        ></add-or-update>
    </div>
</template>

<script>
import { checkMixin } from "@/utils/mixin.js";
import {showcontent} from '@/utils/method.js'
import AddOrUpdate from "@/views/modules/config/child-components/course-add-or-update";
import CheckStatus from "@/views/modules/config/child-components/check-status";
export default {
    mixins: [checkMixin],
    components: {
        AddOrUpdate,
        CheckStatus,
    },
    data() {
        return {
            courseQuery1:"",
            // 获取视屏列表参数
            courseQuery: {
                limit: 10,
                page: 1,
                key: "",
            },
            videoTypelist:[
                {name:'电商运营',id:0},
                {name:'法律',id:1},
                {name:'活动',id:2},
                {name:'共享培训课件',id:3},
            ],
            // 课程列表数据
            courseList: [],
            // 课程总数
            courseTotal: 0,
            // 控制视频播放弹出框的显示隐藏
            dialogVideoVisible: false,
            // 当前播放的视频地址
            videoUrl: "",
            // 要批量删除的课程数组列表
            selectDelete: [],
            // 审核状态参数
            checkQuery: {
                id: null,
                checkStatus: "1",
            },
            loading: false,
        };
    },
    created() {
        this.getAllCourseList();
    },
    methods: {
        chongzhi(){
            this.courseQuery  = {
                key:'',
                videoType:'',
                limit: 10,
                page: 1,
            }
            this.$nextTick(()=>{
                this.getAllCourseList()
            })
        },
        showcontent,
        // 获取所有的视频列表数据
        getAllCourseList(id) {
            id ==1?this.courseQuery.page = 1 :''
            this.loading = true;
            this.courseQuery1 = this.courseQuery.videoType
            if(this.courseQuery.videoType == undefined){
                this.courseQuery1 = ''
            }
            this.$ajaxPost(`/course/list/open?videoType=${this.courseQuery1}`, this.courseQuery).then(
                ({ data }) => {
                    console.log('视频列表数据',data)
                    if (data.code === 0) {
                        data.data.list.forEach(element => {
                            element.createTime = element.createTime.substring(0,10);
                            element.updateTime = element.updateTime.substring(0,10);
                        });
                        this.courseList = data.data.list;
                        this.courseTotal = data.data.totalCount;
                        this.loading = false;
                    }
                }
            );
        },
        // 分页器改变时触发事件
        pageChange(val) {
            this.courseQuery.page = val;
            this.getAllCourseList();
        },
        // 播放视频事件
        videoPlay(url) {
            this.videoUrl = url;
            this.dialogVideoVisible = true;
        },
        // 删除单个课程
        deleteCourse(id) {
            this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$ajaxPost("/course/deleteBatch", [id]).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getAllCourseList();
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        //批量删除课程
        multipleDelete() {
            this.$confirm("批量删除课程,是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let ids = [];
                    this.selectDelete.forEach((item, index) => {
                        ids[index] = item.id;
                    });
                    this.$ajaxPost("/course/deleteBatch", ids).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getAllCourseList();
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 新增或更新操作
        addOrUpdateHandle(id) {
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(parseInt(id));
            });
        },
        // 选中要删除的课程数组
        handleSelectionChange(val) {
            this.selectDelete = val;
        },
        // 失去焦点时保存排序信息
        updateSort(item) {
            console.log(item);
            const { id, sort } = item;
            this.$ajaxPost("/course/update", { id: parseInt(id), sort }).then(
                ({ data }) => {
                    if (data.code === 0) {
                        this.$message.success("排序更新成功");
                        this. getAllCourseList()
                    }
                }
            );
        },
        // 打开审核新添加的banner弹框事件
        examineStatus(id) {
            this.checkQuery.id = id;
            this.$nextTick(() => {
                this.$refs.checkRef.init("/course/update");
            });
        },
        parseVideo() {
            // 关闭对话框暂停视频
            const id = document.querySelector("#video-play");
            id.pause();
        },
        // 点击显示/不显示按钮
        changeShow(item) {
            let { id, showStatus } = item;
            showStatus = showStatus === "1" ? "0" : "1";
            this.$ajaxPost("/course/update", {
                id: parseInt(id),
                showStatus,
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.getAllCourseList();
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.e-input{
    /deep/.el-input__inner{
        text-align: center;
    }
}
.image-slot {
    cursor: pointer;
}
/deep/.el-icon-circle-close{
  color:white
}
</style>